// extracted by mini-css-extract-plugin
export default {"inputWithArrow":"zLZzGb1MoyCMmplXEYpG","arrowBox":"ncXl8l5uDA17LwnbuzOY"};